module.exports = __webpack_public_path__ + "static/media/adv1.0c1e07fb.jpg";